import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
import { Suspense, lazy, useMemo } from "react";
//#region src/use-consultant-reviews.tsx
var LazyConsultantReviews = lazy(() => import("./consultant-reviews-VdFnPCrK.js").then((n) => n.n).then((module) => ({ default: module.ConsultantReviews })));
function ConsultantReviews({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "consultant-reviews" }),
		children: /* @__PURE__ */ jsx(LazyConsultantReviews, { ...props })
	});
}
function ConsultantReviewsContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "consultant-reviews" }),
		children: /* @__PURE__ */ jsx(LazyConsultantReviews, { ...props })
	});
}
var useConsultantReviewsContent = () => {
	return useMemo(() => ({ consultantReviews: { component: ConsultantReviewsContent } }), []);
};
//#endregion
export { ConsultantReviews, useConsultantReviewsContent };
